import axios from 'axios'
import React from 'react'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import api from '../../../../utils/api'

export const MyActionable = ({ roomId, clientData }) => {
  const navigate = useNavigate()

  const handleKYCmodify = async () => {
    const allData = {
      client_id: roomId,
      panNo: clientData?.pan_no,
    }

    try {
      const response = await api.post(
        `advisor/checkkycformodification`,
        allData
      )
      console.log('response',response);
      

      if (response.status === 200 && response.data?.kycstatus==="yes") {
        Swal.fire({
          title: 'KYC Verified!',
          text: 'Client KYC is ready for modification.',
          icon: 'success',
          customClass: {
            confirmButton: 'swal-confirm-btn',
          },
          confirmButtonText: 'Start Modification',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/what-we-will-need-from-you?clientId=${roomId}`)
          }
        })
      } else {
        Swal.fire({
          title: 'Failed!',
          text: response.data?.message || 'KYC modification not allowed.',
          icon: 'error',
        })
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong.',
        icon: 'error',
      })
    }
  }

  return (
    <div className="row pt-5 text-center bggrey">
      <div className="col-12">
        <button className="lrgbutton text-white" onClick={handleKYCmodify}>
          Modify KYC
        </button>
      </div>
    </div>
  )
}
